module.exports = __webpack_public_path__ + "img/register_bj.05a00952.png";